export enum QuestionType {
    Grouping = -1,
    MultipleSingle = 0,
    Matching = 1,
    OpenEnded = 2,
    MultipleMultiple = 3,
    Ordering = 4
}